<div class="main-card mb-3 card">
  <div class="card-body">
    <div class="title-block mb-3">
      <i class="fa fa-fw" [title]="'TR_GOBACK' | translate" (click)="mainService.goBack('currency')"></i>
      <h5 class="card-title">{{ isCreateForm ? ('TR_CREATE_CURRENCY' | translate) : ('TR_UPDATE_CURRENCY' | translate) }}</h5> 
    </div>
    <form (submit)="submitData()" [formGroup]="form">
      <div class="form-row">
        <div class="col-lg-4 col-md-4">
          <div class="position-relative form-group">
            <label for="name">{{ ('TR_NAME' | translate) + mainService.asterisk }}</label>
            <input
              name="name"
              [placeholder]="('TR_NAME' | translate) + mainService.asterisk"
              type="text"
              class="form-control"
              [class.error-border]="isInvalidSubmit && !form.value.name"
              autocomplete="off"
              formControlName="name"
            />
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-lg-4 col-md-4">
          <div class="position-relative form-group">
            <label for="name">{{ ('TR_ISO_CODE' | translate) + mainService.asterisk }}</label>
            <input
              name="isocode"
              [placeholder]="('TR_ISO_CODE' | translate) + mainService.asterisk"
              type="text"
              class="form-control"
              [class.error-border]="isInvalidSubmit && !form.value.isocode"
              autocomplete="off"
              formControlName="isocode"
            />
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-lg-4 col-md-4">
          <div class="position-relative form-group">
            <label for="symbol">{{ ('TR_SYMBOL' | translate) + mainService.asterisk }}</label>
            <input
              name="symbol"
              [placeholder]="('TR_SYMBOL' | translate) + mainService.asterisk"
              type="text"
              class="form-control"
              [class.error-border]="isInvalidSubmit && !form.value.symbol"
              autocomplete="off"
              formControlName="symbol"
            />
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="col-lg-4 col-md-4">
          <div class="position-relative form-group">
            <label for="symbol">{{ ('TR_DECIMAL_COUNT' | translate) + mainService.asterisk }}</label>
            <input
              name="decimalCount"
              [placeholder]="('TR_DECIMAL_COUNT' | translate) + mainService.asterisk"
              type="number"
              class="form-control"
              [class.error-border]="isInvalidSubmit && !form.value.decimalCount"
              autocomplete="off"
              formControlName="decimalCount"
            />
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-lg-4 col-md-4">
          <div class="position-relative form-group">
            <label for="symbol">{{ ('TR_RATE' | translate) + mainService.asterisk }}</label>
            <input
              name="rate"
              [placeholder]="('TR_RATE' | translate) + mainService.asterisk"
              type="number"
              class="form-control"
              [class.error-border]="isInvalidSubmit && !form.value.rate"
              autocomplete="off"
              formControlName="rate"
            />
          </div>
        </div>
      </div>

      <div class="position-relative form-check">
        <input name="symbolPosition" id="symbolPosition" type="checkbox" class="form-check-input" formControlName="symbolPosition">
        <label for="symbolPosition" class="form-check-label">{{ 'TR_SYMBOL_POSITION_LEFT' | translate }}</label>
      </div>
      <div class="position-relative form-check">
        <input name="isMain" id="isMain" type="checkbox" class="form-check-input" formControlName="isMain">
        <label for="isMain" class="form-check-label">{{ 'TR_IS_MAIN' | translate }}</label>
      </div>
      <app-submit-button
        [spinnerId]="submitSpinnerId"
        [buttonName]="isCreateForm ? ('TR_CREATE' | translate) : ('TR_UPDATE' | translate)"
        [isInvalidSubmit]="isInvalidSubmit"
        [isFormValid]="form.valid"
      ></app-submit-button>
    </form>
  </div>
</div>